<template>
  <router-view />
</template>

<script setup lang="ts">
import { onMounted } from 'vue';

onMounted(() => {
  // Ref: https://web.dev/articles/bfcache
  window.addEventListener('pageshow', (event) => {
    if (event.persisted && !localStorage.getItem('editor-token')) {
      // Se o token não existe mais no localStorage, destrói o cache do browser
      window.location.reload();
    }
  });
});
</script>
